//首页
export default {
  //首页
  videoArea: resolve => {
    require.ensure([], () => {
      resolve(require('@/views/video-area/list.vue'));
    }, '/modules/video-area/list');
  },
  videoBanner: resolve => {
    require.ensure([], () => {
      resolve(require('@/views/video-area/video-banner.vue'));
    }, '/modules/video-area/video-banner');
  }
}



// WEBPACK FOOTER //
// ./src/router/modules/video-area.js